<script setup lang="ts">

import Container from "~/components/layout/Container.vue";
const route = useRoute()
useHead({
	title: "Neuronoir | About",
	meta: [
		{ name: 'description', content: "Neuronoir serves as a hub for a group of friends who share a passion for dark and heavy music. In here you'll find our releases, articles written about things we enjoy that are adjacent to our artistic pursuits and a shop with our merchandise." },
		{ name: 'keywords', content: 'heavy music, dark music, Romania, about' },
		{ property: 'og:title', content: 'Neuronoir | About' },
		{ property: 'og:description', content: "Neuronoir serves as a hub for a group of friends who share a passion for dark and heavy music. In here you'll find our releases, articles written about things we enjoy that are adjacent to our artistic pursuits and a shop with our merchandise." },
		{ property: 'og:url', content: 'https://www.neuronoir.art/about' },
        { property: 'canonical', content: 'https://neuronoir.art' + route.path },
	]
})
</script>

<template>
	<Container class="bg-neurodarkgreyvar">
		<div class="py-10">
			<div class="grid grid-cols-2 gap-5">
				<div class="col-span-1 max-[1000px]:col-span-2 mb-10">
					<h2 class="mb-10 text-white text-xl uppercase font-bold">About</h2>
					<h4 class="text-zinc-400">Neuronoir serves as a hub for a group of friends who share a passion for
						dark and heavy music. In here you'll find our releases, articles written about things we enjoy
						that are adjacent to our artistic pursuits and a shop with our merchandise. </h4>
					<div class="mt-10">
						<!-- social - start -->
						<div class="flex gap-4">
							<a href="https://discord.gg/w3GJKkh7J3" target="_blank"
								class="text-gray-400 hover:text-gray-500 active:text-gray-600 transition duration-100">
								<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="w-6 h-6" width="24"
									height="24" viewBox="0 0 640 512">
									<path d="M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z">
									</path>
								</svg>
							</a>
							<a href="https://facebook.com/neuronoir.art" target="_blank"
								class="text-gray-400 hover:text-gray-500 active:text-gray-600 transition duration-100">
								<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="w-6 h-6" width="24"
									height="24" viewBox="0 0 640 512">
									<path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z">
									</path>
								</svg>
							</a>
							<a href="https://www.instagram.com/neuronoir.art/" target="_blank"
								class="text-gray-400 hover:text-gray-500 active:text-gray-600 transition duration-100">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor"
									class="w-6 h-6" width="24" height="24">
									<path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z">
									</path>
								</svg>
							</a>
							<a href="https://www.youtube.com/@neuronoirart" target="_blank"
								class="text-gray-400 hover:text-gray-500 active:text-gray-600 transition duration-100">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 576 512"
									fill="currentColor">
									<path d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z" />
								</svg>
							</a>
						</div>
					</div>
					<div class="w-2/3 text-zinc-600 mt-5">Neuronoir is a product of Aural Function. Learn more about
						Aural Function here:
						<a href="https://aural-function.com" target="_blank" class="text-neurolink">aural-function.com
						</a>
					</div>
					<div class="text-zinc-600">AURAL FUNCTION S.R.L.</div>
					<div class="text-zinc-600">CIF: 47755049</div>
					<div class="text-zinc-600">EUID: ROONRC.J35/957/2023</div>
				</div>
				<div class="col-span-1 max-[1000px]:col-span-2">
					<div class="mb-5">
						<h3 class="mb-10 text-white text-xl uppercase font-bold">Contact</h3>
					</div>
					<form class=" grid sm:grid-cols-2 gap-4 mx-auto" action="https://api.web3forms.com/submit"
						method="POST">
						<input type="hidden" name="access_key" value="3e51c2ce-b93d-426c-b720-58003d1aa30d">
						<div>
							<label for="first-name" class="inline-block text-zinc-400 text-sm sm:text-base mb-2">First
								name
							</label>
							<input name="first-name" id="first-name" autocomplete="first-name"
								class="w-full bg-gray-50 text-zinc-400 border focus:ring ring-lime-300 rounded outline-none transition duration-100 px-3 py-2">
						</div>
						<div>
							<label for="last-name" class="inline-block text-zinc-400 text-sm sm:text-base mb-2">Last
								name
							</label>
							<input name="last-name" id="last-name"
								class="w-full bg-gray-50 text-zinc-400 border focus:ring ring-lime-300 rounded outline-none transition duration-100 px-3 py-2">
						</div>
						<div class="sm:col-span-2">
							<label for="company" class="inline-block text-zinc-400 text-sm sm:text-base mb-2">Company
							</label>
							<input name="company" id="company" autocomplete="company"
								class="w-full bg-gray-50 text-zinc-400 border focus:ring ring-lime-300 rounded outline-none transition duration-100 px-3 py-2">
						</div>
						<div class="sm:col-span-2">
							<label for="email" class="inline-block text-zinc-400 text-sm sm:text-base mb-2">Email
							</label>
							<input name="email" id="email" autocomplete="email"
								class="w-full bg-gray-50 text-zinc-400 border focus:ring ring-lime-300 rounded outline-none transition duration-100 px-3 py-2">
						</div>
						<div class="sm:col-span-2">
							<label for="message" class="inline-block text-zinc-400 text-sm sm:text-base mb-2">Message
							</label>
							<textarea name="message" id="message"
								class="w-full h-64 bg-gray-50 text-zinc-400 border focus:ring ring-lime-300 rounded outline-none transition duration-100 px-3 py-2"></textarea>
						</div>
						<div class="sm:col-span-2 flex justify-between items-center">
							<button class="inline-block bg-neuroprimary text-white text-center rounded px-8 py-3">
								Send
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</Container>
</template>

<style scoped></style>
